/* eslint eqeqeq: "off", no-extend-native: "off", no-throw-literal: "off", no-use-before-define: "off", react-hooks/exhaustive-deps: off */
import React, { useEffect, useState } from 'react';
import './css/styles.css';
import './css/layout.css';
import Interpreter from './components/interpreter/Interpreter';
import Projects from './components/Projects.js';
import Header from './components/Header.js';
import NewProjectModal from './components/NewProjectModal';
import { languageDef, configuration } from './components/editorOptions'
import { includes } from './components/interpreter/includes.js';
import MonacoEditor from 'react-monaco-editor';
import Chart from './components/Chart';
import DataTable from './components/DataTable';
import Terminal from './components/Terminal';
import 'firebase/auth';
import twoPaneImg from './images/twopane.png';
import threePaneImg from './images/three-pane.png';
//import { useUser } from 'reactfire';
//import WorkerBuilder from './components/worker-builder';
//import Worker from './components/logoWorker';

import MotionTable from './components/MotionTable';
import { set } from './redux/reducers/projectIdSlice';

import { store } from './redux/store';
import { load } from './redux/reducers/packetDataSlice';

let interpreter, projects;
//let instance = new WorkerBuilder(Worker);

const App = () => {

  //TEST#########################################################################################
  
  //TODO:
  // I need a way of updating the language definition when the store changes
  // The idea as a whole being that words created by the user can be added to the language definition

  //I may need to look at intperpreter state to apply changes here dynamically

  const [test, setTest] = useState(store.getState().test.value);

  useEffect(() => {
    var ld = {...languageDef, keywords:[...languageDef.keywords, ...test]};
    // console.log('ld:', ld);
    // console.log(interpreter);
  }, [interpreter]);


  
  //TEST#########################################################################################


  //const { data: user } = useUser();
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [view, setView] = useState('main');
  const [code, setCode] = useState(`to go
  print 'Hello World'
end`,);

  let editor = null;

  const [twoPane, setTwoPane] = useState(false)
  const [horizontalOffset, setHorizontalOffset] = useState(0);
  const [chartType, setChartType] = useState('');
  const [chartDataSingle, setChartDataSingle] = useState([]);
  const [chartDataTop, setChartDataTop] = useState([]);
  const [chartDataBottom, setChartDataBottom] = useState([]);
  const [chartOptionsTop, setChartOptionsTop] = useState({


    responsive: true,
    maintainAspectRatio: false,
  });

  const [chartOptionsBottom, setChartOptionsBottom] = useState({

    responsive: true,
    maintainAspectRatio: false,
  });
  const [chartOptionsSingle, setChartOptionsSingle] = useState({

    responsive: true,
    maintainAspectRatio: false,
  });



  useEffect(() => {
    setup();
  },
    []
  );


  const setup = () => {

    /*
    Web worker experiment
    *****
    instance.onmessage = (message) => {
      if (message) {
        console.log("Message from worker", message.data);
      }
    };
    */    


    //Setup wakelock to keep the screen awake
    console.log("Setting up wakelock...");

    const wakeLock = async () => {
      if (document.visibilityState !== 'visible') return; //if not visible, don't wakelock
      
      try {
        const lock = await navigator.wakeLock.request('screen');
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    }
    wakeLock(); //Initial request
    document.addEventListener('visibilitychange', wakeLock); // rerequest on visibility change



    // console.log("Serial API Check:", checkIfSerialCapable());

    setHorizontalOffset(document.getElementById("gutter").getBoundingClientRect().left);

    interpreter = new Interpreter(
      {
        updateChartOptions: updateChartOptions,
        updateChartType: updateChartType,
        pushNewChartData: pushChartData,
      }
    );

    projects = new Projects(updateCode);
    interpreter.setup();

    window.onresize = interpreter.handleResize.bind(interpreter);

    const connectButton = document.getElementById('connectButton');
    const disconnectButton = document.getElementById('disconnectButton');

    if (connectButton !== null && disconnectButton !== null) {
      connectButton.addEventListener('keydown', (e) => { if (e.key == "Enter") { interpreter.openSerialPort.bind(interpreter) } });
      disconnectButton.addEventListener('keydown', (e) => { if (e.key == "Enter") { interpreter.disconnectSerialPort.bind(interpreter) } });

      connectButton.addEventListener('click', interpreter.openSerialPort.bind(interpreter));
      disconnectButton.addEventListener('click', interpreter.disconnectSerialPort.bind(interpreter));
    }

    ////    this.setState({
    //     includes: includes
    //    });

  }

  const dragToResize = (e) => {

    e.preventDefault();

    function handleDrag(e) {
      interpreter.handleResizeHorizontal(e.clientX - horizontalOffset);
    }

    function handleMouseUp(e) {
      document.removeEventListener('mousemove', handleDrag)
      document.removeEventListener('mouseup', handleMouseUp)
      return;
    }

    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('mousemove', handleDrag)
  }


  const updateChartType = (newType) => {
    setChartType(newType);
  }

  const updateChartOptions = (chartType, newOptions) => {
    if (chartType == "single") {
      setChartOptionsSingle(newOptions)
    }

    if (chartType == "top") {
      setChartOptionsTop(newOptions);
    }

    if (chartType == "bottom") {
      setChartOptionsBottom(newOptions);
    }

  }


  const pushChartData = (chartType, newData) => {
    if (chartType == "single") {
      setChartDataSingle(newData);
      return;
    }
    if (chartType == "top") {
      setChartDataTop(newData);
      return
    }
    if (chartType == "bottom") {
      setChartDataBottom(newData);
      return;
    }

  }

  const checkIfSerialCapable = () => {
    if ('serial' in navigator) {
      return true;
    } else {
      return false
    }
  }


  const updateCode = (newCode) => {
    setCode(newCode);
  }


  const toggleShowNewProjectModal = () => {
    setShowNewProjectModal(!showNewProjectModal);
  }


  const editorWillMount = monaco => {




    editor = monaco
    if (!monaco.languages.getLanguages().some(({ id }) => id === 'jslogo')) {
      // Register a new language
      monaco.languages.register({ id: 'jslogo' })
      // Register a tokens provider for the language
      monaco.languages.setMonarchTokensProvider('jslogo', languageDef)
      // Set the editing configuration for the language
      monaco.languages.setLanguageConfiguration('jslogo', configuration)


    }




    /*
      Updated Colors:
      [x]DarkBlue(Strings): 0b3a9a
      [x]BlueGreen(Pre-defined words): 0080a6
      []Green(Comments): 179847
      [x]Purple(commands): 7b44cd
      [x]Pink(start/end of word definitions): e234bb, D21EAB
      [x]Orange(Numbers): dc560d, CA4F0C
      [x]DarkGrey(Error): 5e5c5a
      Black(else): 000000
    */


    monaco.editor.defineTheme('jslogo', {
      base: 'vs', //vs-dark for dark theme, vs for light
      inherit: true,
      rules: [
        //Old color rules
        // { token: 'custom-words', foreground: 'd70087' }, //was FF7F7F, A80000. I like d70087
        // { token: 'numbers-custom', foreground: 'BD5500' }, //Currently setup to change number color, FFFD8A, BD5500
        // { token: 'compound-keywords', foreground: '005faf' }, //was 569cd6, 215987, 005faf
        // { token: 'error', foreground: 'D60000' }, //800080
        // { token: 'keywords-new', foreground: '8f53a1' },

        // Updated colors
        {token: 'strings-updated', foreground: '0b3a9a'},
        {token: 'predefined-words', foreground: '0080a6'},
        {token: 'comments', foreground: '179847'},
        {token: 'commands', foreground: '7b44cd'},
        {token: 'word-definition', foreground: 'D21EAB'},
        {token: 'numbers-custom', foreground: 'CA4F0C'},
        {token: 'error', foreground: '5e5c5a'},
      ],
      colors: {
        keywords: 'yellow'
      },
    });


  }




  const editorDidMount = (editor, monaco) => {
    editor.focus();
  }


  const options = {
    brackets: [
      ["{", "}"], ["[", "]"], ["(", ")",]
    ],
    comments: {
      lineComment: ";",
    },
    quickSuggestionsDelay: 500,
    selectOnLineNumbers: true,
    automaticLayout: true,
    minimap: {
      enabled: false
    },
  };

  const [dataMode, setDataMode] = useState('data'); //data or motion

  const handleDataChange = (mode) => {
    //set the date to either data or motion
    
    console.log('mode:', mode);
    console.log('dataMode:', dataMode);


    //I have to go to a meeting but there is definetly a way to squish these two if statements together.
    //Will revisit when I get back
    if (mode == 'motion' && dataMode == 'data' || mode == 'data' && dataMode == 'motion') {
      store.dispatch(load([]));
    }
    if(mode == 'data' || mode == 'motion'){
      setDataMode(mode);
    }
    setView(mode);
  }

  return (
    <div>
      <Header
        toggleNewProjectModal={toggleShowNewProjectModal}
        interpreter={interpreter}
        updateCode={updateCode}
        dataMode={dataMode}
        setDataMode={handleDataChange}
      />

      <div style={{ height: "20px" }}></div>
      <div className="main-container">
        {showNewProjectModal ?
          <NewProjectModal
            currentView={view}
            setView={setView}
            setDataMode={setDataMode}
            currentDataMode={dataMode}
            toggleModal={toggleShowNewProjectModal}
            updateCode={updateCode}
          />
          :
          null}
        <div className="top-buttons">

          <ul>
            <li id="go-button" onClick={() => { interpreter.runLine("go") }} tabIndex="0">Go</li>
          </ul>
          <ul id="view-tabs" className={twoPane ? 'tabs-disabled' : null}>
            <li tabIndex="0" onKeyDown={(e) => { if (e.key == "Enter" || !twoPane) { setView('main') } }} onClick={() => { if(!twoPane){setView('main'); interpreter.runLine("st") }}} className={view == "main" ? "activeButton" : null} >Canvas</li>
            <li tabIndex="0" onKeyDown={(e) => { if (e.key == "Enter" || !twoPane) { setView('graph') } }} onClick={() => {if(!twoPane){setView('graph')}}} className={view == "graph" ? "activeButton" : null}>Plots</li>

            {dataMode == "motion" ?   
              <li id='data-tab' tabIndex="0" onKeyDown={(e) => { if (e.key == "Enter"|| !twoPane) { handleDataChange('motion') } }} onClick={() => {if(!twoPane){handleDataChange('motion')}}} className={view == "motion" ? "activeButton" : null}>Motion Data</li>
              :
              <li id='data-tab' tabIndex="0" onKeyDown={(e) => { if (e.key == "Enter"|| !twoPane) { handleDataChange('data') } }} onClick={() => {if(!twoPane){handleDataChange('data')}}} className={view == "data" ? "activeButton" : null}>Data</li>
            }
          </ul>
        </div>
        <div style={{ position: 'fixed', right: '1vw', top: '55px', height: '35px' }}>
          <img src={threePaneImg}
            style={{ cursor: 'pointer', maxHeight: '100%', marginRight: '10px', padding: '5px' }}
            className={twoPane ? null : "active-pane-button"}
            onClick={() => { interpreter.showCanvas(); setTwoPane(false) }}
            onKeyDown={(e) => { if (e.key == "Enter") { interpreter.showCanvas(); setTwoPane(false) } }}
            tabIndex="0"
          />
          <img src={twoPaneImg}
            style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100%', padding: '5px' }}
            className={twoPane ? "active-pane-button" : null}
            onClick={() => { interpreter.hideCanvas(); setTwoPane(true) }}
            onKeyDown={(e) => { if (e.key == "Enter") { interpreter.hideCanvas(); setTwoPane(true) } }}
            tabIndex="0"
          />

        </div>

        <input id="load" type="file" onChange={() => projects.loadFile()} style={{ display: "none" }} />

      </div>

      <div className="interfaceGrid" id="mainInterfaceGrid">
        <div className="codeEntry" id="codeEntryDiv">
          <MonacoEditor
            language="jslogo"
            theme="jslogo"
            value={code}
            options={options}
            onChange={updateCode}
            editorDidMount={editorDidMount}
            editorWillMount={editorWillMount}
          />

          <textarea id="procs" style={{ whiteSpace: "nowrap", display: "none" }} value={code} readOnly>
          </textarea>
          <textarea id="includes" spellCheck="false" style={{ display: "none", whiteSpace: "nowrap", overflow: "visible" }} />
        </div>

        <div id="gutter" onMouseDown={(e) => { dragToResize(e) }} ></div>
        <div className="chartArea" id="chartAreaWrapper">

          <div id="cnvframe" className={view == "main" ? null : "hide"} style={{ height: "100%", width: "100%" }}>
            <canvas className="cnv" id="canvas" >
              <div className="turtle" id="turtle">
                <img id="turtleimage" src="turtle.svg" alt="Turtle avatar" />
              </div>
            </canvas>
          </div>

          <div id="chartFrame" className={view == "graph" ? null : "hide"} style={{ height: "100%", width: "100%" }}>
            <Chart
              chartType={chartType}
              chartDataSingle={chartDataSingle}
              chartDataTop={chartDataTop}
              chartDataBottom={chartDataBottom}
              chartOptionsTop={chartOptionsTop}
              chartOptionsBottom={chartOptionsBottom}
              chartOptionsSingle={chartOptionsSingle}
            />

          </div>
          
          <div id="dataFrame" className={view == "data" ? null : "hide"} style={{ height: "100%", width: "100%" }}>
            <DataTable />
          </div>

          <div id="dataFrame" className={view == "motion" ? null : "hide"} style={{ height: "100%", width: "100%" }}>
            <MotionTable />
          </div>

        </div>
        <Terminal
          interpreter={interpreter}
        />
      </div>
      <textarea id="includes" style={{ display: "none" }} value={includes} readOnly />
    </div >
  );

}

export default App;
